import type { CommandAction } from '../CommandPalette'
import type { Section } from '../../types'
import { buildAccountCommandActions } from './command-actions/account'
import { buildNavigationCommandActions } from './command-actions/navigation'
import { buildProfileCommandActions } from './command-actions/profile'
import type { TranslateFn } from './command-actions/types'

export const buildCommandActions = (
  t: TranslateFn,
  setSection: (section: Section) => void,
  handleLogout: () => void | Promise<void>,
  options?: { isCustomerOnly?: boolean; userCapabilities?: string[] },
): CommandAction[] => {
  const context = { t, setSection, handleLogout, userCapabilities: options?.userCapabilities ?? [] }
  return [
    ...buildNavigationCommandActions(context, options),
    ...buildProfileCommandActions(context, options),
    ...buildAccountCommandActions(context),
  ]
}
